import { render, staticRenderFns } from "./ErrorIcon.vue?vue&type=template&id=0e19b264&scoped=true&"
import script from "./ErrorIcon.vue?vue&type=script&lang=js&"
export * from "./ErrorIcon.vue?vue&type=script&lang=js&"
import style0 from "./ErrorIcon.vue?vue&type=style&index=0&id=0e19b264&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e19b264",
  null
  
)

export default component.exports